import { render } from "./ServiceCarousel.vue?vue&type=template&id=a2fef058&scoped=true"
import script from "./ServiceCarousel.vue?vue&type=script&lang=js"
export * from "./ServiceCarousel.vue?vue&type=script&lang=js"

import "./ServiceCarousel.vue?vue&type=style&index=0&id=a2fef058&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2fef058"]])

export default __exports__